import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d022a3ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder", "onKeydown", "innerHTML"]

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue'

interface Props {
  placeholder?: string
  modelValue: string
  minHeight?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'editor',
  props: {
    placeholder: null,
    modelValue: null,
    minHeight: { default: 30 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "submit"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'update:modelValue', val: string): void
  (e: 'input', event: Event): void
  (e: 'focus', event: Event): void
  (e: 'blur', event: Event): void
  (e: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { placeholder?: string, modelValue: string, minHeight: number }

_useCssVars(_ctx => ({
  "24b64272": (_unref(minHeight)),
  "59c05f82": (_unref(padding))
}))



const range = ref<Range>()
const editorRef = ref<HTMLDivElement>()
const text = ref()
const isLocked = ref(false)
const active = ref(false)

const minHeight = computed(() => props.minHeight + 'px')

const padding = computed(() => (props.minHeight == 30 ? '4px 10px' : '8px 12px'))



watch(
  () => props.modelValue,
  val => {
    if (!isLocked.value) text.value = val
  }
)

function onFocus(event: Event) {
  emit('focus', event)
  isLocked.value = true
  active.value = true
}

function onBlur(event: Event) {
  // 记录光标
  range.value = window.getSelection()?.getRangeAt(0)
  emit('blur', event)
  if (!editorRef.value?.innerHTML) active.value = false
  isLocked.value = false
}

function onInput(event: Event) {
  const { innerHTML } = event.target as HTMLDivElement
  emit('update:modelValue', innerHTML)
  emit('input', event)
}

function addText(val: string) {
  let selection = window.getSelection()
  if (selection) {
    selection.removeAllRanges()
    // 为空初始化光标
    if (!range.value) {
      editorRef.value?.focus()
      range.value = selection.getRangeAt(0)
    }
    // 删除选中内容
    range.value.deleteContents()

    // 添加内容
    range.value.insertNode(range.value.createContextualFragment(val))

    range.value.collapse(false)
    selection.addRange(range.value)

    emit('update:modelValue', editorRef.value?.innerHTML || '')
    const event = editorRef.value as unknown as Event
    emit('input', event)
  }
}

function clear() {
  if (editorRef.value) {
    editorRef.value.innerHTML = ''
    emit('update:modelValue', editorRef.value.innerHTML)
    active.value = false
  }
}

function focus() {
  nextTick(() => {
    editorRef.value?.focus()
  })
}

const keyDown = (e: KeyboardEvent) => {
  if (e.ctrlKey && e.key == 'Enter') {
    //用户点击了ctrl+enter触发
    // console.log('ctrl+enter')
    emit('submit')
  } else {
    //用户点击了enter触发
    // console.log('enter')
  }
}

onMounted(() => {
  editorRef.value?.addEventListener('keyup', (event: Event) => {
    const el = event.target as HTMLDivElement
    if (el.innerHTML == '<br>') {
      el.innerHTML = ''
    }
  })
})

expose({
  addText,
  clear,
  focus
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["u-editor", { active: active.value }])
  }, [
    _createElementVNode("div", {
      ref_key: "editorRef",
      ref: editorRef,
      class: "rich-input",
      contenteditable: "true",
      placeholder: __props.placeholder,
      onFocus: onFocus,
      onInput: onInput,
      onBlur: onBlur,
      onKeydown: _withKeys(keyDown, ["enter"]),
      innerHTML: text.value
    }, null, 40, _hoisted_1)
  ], 2))
}
}

})